import { useEffect } from 'react'
import clsx from 'clsx'
import { toast } from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'

import { useAuth } from 'hooks/useAuth'
import { useStore } from 'hooks/useStore'
import { useModal } from 'contexts/modal-manager-context'
import { useDeleteAccountMutation } from 'graphql/generated/scheme'
import { Button } from 'components/atoms/button'

interface Props {
	openDelete: boolean
	setOpenDelete: (...args: any) => any
}

export function DeleteAccountBlock({ openDelete, setOpenDelete }: Props) {
	const navigate = useNavigate()
	const { logout } = useAuth()
	const { clearStore } = useStore()
	const { openModal } = useModal()
	const [deleteAccount, { data: deleteAccountData, loading: deleteAccountLoading, error: deleteAccountError }] =
		useDeleteAccountMutation()

	useEffect(() => {
		if (deleteAccountData) {
			logout(null, null, () => {
				clearStore()
				navigate('/auth/login', { replace: true })
			})
		}
		if (deleteAccountError) {
			toast.error(`Delete account failure!`)
		}
	}, [deleteAccountData, deleteAccountError])

	return (
		<>
			<div className="min-[1440px]:w-[1440px] w-full fixed top-0 left-1/2 -translate-x-1/2 h-0 z-[2]">
				<div className="absolute top-0 right-0 lg:w-[calc(100%-232px)] w-full h-0">
					<div
						className={clsx(
							'bg-primary-surface/[0.4] backdrop-blur-lg px-4 pb-6 pt-[88px] sm:px-8 sm:pb-8 -translate-y-full transition-all duration-300',
							{ '!translate-y-0': openDelete }
						)}
					>
						<div className="font-bold text-2xl">Delete account</div>
						<div className="mt-2 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
							<div className="leading-5 max-w-[448px]">
								If you delete your account you will have 90 days to reactivate or your data will be
								permanently deleted.
							</div>
							<div className="grid grid-cols-2 gap-3 sm:flex sm:shrink-0 sm:gap-4">
								<Button variant="primary" size="lg" onClick={() => setOpenDelete(false)}>
									Cancel
								</Button>
								<Button
									variant="secondary"
									size="lg"
									className="text-secondary-red"
									onClick={() => {
										setOpenDelete(false)
										openModal('delete-account', {
											onConfirm: () => deleteAccount(),
											loading: deleteAccountLoading,
										})
									}}
								>
									Delete
								</Button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
